// Put your applicaiton javascript here
function changeImage(url){
  $("#main_image").css("background-image", url);
}

function toggleNav(){
  var nav = $("#mobile_nav");
  if(nav.css("display") == "none"){
    nav.css("display", "block");
  } else {
    nav.css("display", "none");
  }
}

